import React from 'react';
import styled from 'styled-components';
import ScoreItem from './components/ScoreItem';
import { useSymptomTrackerContext } from '../../contexts';

const Container = styled.div`
  display: block;
  position: relative;
`;
const BoxBody = styled.div`
  display: block;
  text-align: center;
  padding: 0 24px;
`;
const TextFieldQuestion = styled.div`
  width: 100%;
  font-weight: bold;
  font-size: 24px;
  color: #2b2b2b;
  margin-top: 21px;

  .active {
    color: #39a1ac;
  }
`;
const ImageDyspnea = styled.img`
  margin: 48px 0 53px;
`;
const BoxIncrement = styled.div`
  width: 100%;
  height: 420px;
  display: flex;
  background: #06a3b4;
  border-radius: 16px 16px 0px 0px;
  align-items: center;
  flex-direction: column;
  padding: 16px 24px;

  @media only screen and (min-height: 700px) {
    position: fixed;
    bottom: 0;
    left: 0;
  }
`;
const IncrementTitle = styled.span`
  font-size: 16px;
  line-height: 22px;
  color: #e7f6f8;
`;
const Line = styled.div`
  width: 100%;
  height: 0.67px;
  margin-top: 8px;
  background-color: #a1d8df;
`;
const BoxNoteLabel = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  margin-top: 16px;
  color: #ffffff;
  margin-bottom: 2px;
  max-width: 325px;

  ${props => props?.isShowValue && `margin-bottom: 14px;`}
`;
const NoteLabel = styled.span`
  max-width: 132px;
  font-size: 14px;
  letter-spacing: 0.25px;
  line-height: 22px;

  :last-child {
    text-align: end;
  }
`;
const BoxScore = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 325px;
`;
const BoxActionIncrease = styled.div`
  display: flex;
  margin-top: 48px;
  align-items: center;
`;
const Decrease = styled.img`
  width: 48px;
  height: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(255, 255, 255, 0.25);
  border-radius: 23px;
  color: #e7f6f8;
  font-size: 23px;
  margin-right: 26px;
  cursor: pointer;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
`;
const Increase = styled.img`
  width: 48px;
  height: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(255, 255, 255, 0.25);
  border-radius: 23px;
  color: #e7f6f8;
  font-size: 23px;
  cursor: pointer;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
`;

export default function CoughTrackerContainer() {
  const { lvCough, symptomTrackerAction } = useSymptomTrackerContext();
  return (
    <Container>
      <BoxBody>
        <TextFieldQuestion>
          สัปดาห์ที่แล้ว อาการ<span className="active">ไอ</span>
          <br />
          ของคุณอยู่ในขั้นไหน?
        </TextFieldQuestion>
        <ImageDyspnea src="/images/img-cough.svg" alt="img dyspnea" />
      </BoxBody>
      <BoxIncrement>
        <IncrementTitle>
          เลือกหมายเลข ที่ตรงกับอาการของคุณมากที่สุด
        </IncrementTitle>
        <Line />
        <BoxNoteLabel isShowValue={!isNaN(lvCough)}>
          <NoteLabel>ไม่มีอาการไอ</NoteLabel>
          <NoteLabel>
            มีอาการไอมากจน
            <br />
            ไม่สามารถทำกิจวัตร
            <br />
            ประจำวันได้
          </NoteLabel>
        </BoxNoteLabel>
        <BoxScore>
          <ScoreItem defaultScore={0} color="#339900" currentScore={lvCough} />
          <ScoreItem defaultScore={1} color="#339900" currentScore={lvCough} />
          <ScoreItem defaultScore={2} color="#8AB82E" currentScore={lvCough} />
          <ScoreItem defaultScore={3} color="#8AB82E" currentScore={lvCough} />
          <ScoreItem defaultScore={4} color="#FFCC00" currentScore={lvCough} />
          <ScoreItem defaultScore={5} color="#FFCC00" currentScore={lvCough} />
          <ScoreItem defaultScore={6} color="#FFCC00" currentScore={lvCough} />
          <ScoreItem defaultScore={7} color="#FF9966" currentScore={lvCough} />
          <ScoreItem defaultScore={8} color="#FF9966" currentScore={lvCough} />
          <ScoreItem defaultScore={9} color="#CC3300" currentScore={lvCough} />
          <ScoreItem defaultScore={10} color="#CC3300" currentScore={lvCough} />
        </BoxScore>
        <BoxActionIncrease isActive={!isNaN(lvCough)}>
          <Decrease
            src="/icons/decrease.svg"
            onClick={() =>
              symptomTrackerAction?.handleCoughIncreaseScore(
                lvCough,
                'decrease',
              )
            }
          />
          <Increase
            src="/icons/increase.svg"
            onClick={() =>
              symptomTrackerAction?.handleCoughIncreaseScore(
                lvCough,
                'increase',
              )
            }
          />
        </BoxActionIncrease>
      </BoxIncrement>
    </Container>
  );
}
